import React from 'react';
import { useAITTheme } from '../ui/theme';

const CityIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 91.48">
      <path
        fill={theme.tokens.colors.brand.primary}
        d="M0,0v91.48h67.83V0H0ZM20.06,58.75H7.4v-12.66h12.66v12.66ZM20.06,39.65H7.4v-12.66h12.66v12.66ZM20.06,20.54H7.4V7.88h12.66v12.66ZM40.24,58.75h-12.66v-12.66h12.66v12.66ZM40.24,39.65h-12.66v-12.66h12.66v12.66ZM40.24,20.54h-12.66V7.88h12.66v12.66ZM60.43,58.75h-12.66v-12.66h12.66v12.66ZM60.43,39.65h-12.66v-12.66h12.66v12.66ZM60.43,20.54h-12.66V7.88h12.66v12.66Z"
      />
      <path
        fill={theme.tokens.colors.brand.primary}
        d="M75.93,35.59v55.89h24.07v-55.89h-24.07ZM95.89,63.53h-15.85v-8.35h15.85v8.35ZM95.89,48.11h-15.85v-8.35h15.85v8.35Z"
      />
    </svg>
  );
};

export default CityIcon;
